import Shift8Points from './shift8-points';

export default Shift8Points;
